<template>
  <v-card flat>
    <v-card-title class="title-font">
      TISSUE SCAN OF RESTORING ARCH <v-spacer />
      <div
        v-if="showErrors && !photogrammetryHealingCap"
        class="error--text text-body-2"
      >
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please make a selection </span>
      </div>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      What healing cap or scan body did you use when scanning the restoring arch
      tissue?
    </v-card-subtitle>
    <v-card-text class="pa-4">
      <v-autocomplete
        v-model="photogrammetryHealingCap"
        :items="mappedHealingCaps"
        dense
        outlined
        hide-details
        :menu-props="{ rounded: '10' }"
        placeholder="Healing Cap"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import client from "@/lib/ApiClient"

export default {
  name: "PhotogrammetryHealingCaps",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      showErrors: false
    }
  },

  computed: {
    ...mapGetters(["exportComponents"]),

    photogrammetryHealingCap: {
      get() {
        return this.value
      },
      set(val) {
        this.showErrors = false
        this.$emit("input", val)
      }
    },

    mappedHealingCaps() {
      if (!this.exportComponents) return []
      return this.exportComponents
        .filter((c) => c.type === "Healing Cap")
        .map((c) => {
          return {
            text: c.name,
            value: c.code
          }
        })
    }
  },

  methods: {
    ...mapActions(["setExportComponents"]),

    validate() {
      if (!this.photogrammetryHealingCap) this.showErrors = true
      this.valid = !!this.photogrammetryHealingCap
      return !!this.photogrammetryHealingCap
    },

    async fetchExportComponents() {
      this.loading = true
      this.setExportComponents(
        await client.gateway.components.fetchExportComponents()
      )
      this.loading = false
    }
  },

  created() {
    this.form.register(this)
  },

  async mounted() {
    if (!this.exportComponents) this.fetchExportComponents()
  }
}
</script>
